export const carrierPortalPages = [
  'carrier-request-list',
  'carrier-transport-list',
  'carrier-tender-hash',
  'carrier-tender-list',
  'carrier-contract-list',
  'carrier-contract-hash',
]
